<template>
  <div class="common-main">
    <!-- 头部 -->
    <header class="common-header">
      <div class="left">
        <el-select v-model="listForm.fileType" clearable placeholder="全部类型" @change="initPage">
          <el-option label="导入" :value="1" />
          <el-option label="导出" :value="2" />
        </el-select>
        <el-select v-model="listForm.fileStatus" clearable placeholder="处理状态" @change="initPage">
          <el-option label="待处理" :value="1" />
          <el-option label="处理中" :value="2" />
          <el-option label="成功" :value="3" />
          <el-option label="失败" :value="4" />
          <el-option label="已取消" :value="5" />
          <el-option label="已中断" :value="6" />
        </el-select>
        <el-date-picker v-model="taskTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :default-time="['00:00:00', '23:59:59']" @change="changeDatePicker" />
        <el-button @click="getFileTaskList" :loading="loading">刷新</el-button>
      </div>
    </header>

    <!-- 主体 -->
    <section class="common-section">
      <el-table :data="fileTaskList" v-loading="loading" height="100%">
        <el-table-column prop="fileName" label="文件名">
          <template slot-scope="{ row }">
            <span v-if="row.fileType === 1" @click="download(row.filePath)">{{ row.fileName }}</span>
            <span v-else>{{ row.fileName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="creater" label="操作人" />
        <el-table-column prop="createDate" label="操作时间">
          <template slot-scope="{row}">
            <span>{{timeToString(row.createDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fileType" label="类型">
          <template slot-scope="{row}">
            <span>{{row.fileType===1?'文件导入':'文件导出'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="taskTypeName" label="数据模块" />
        <el-table-column prop="fileStatus" label="处理状态">
          <template slot-scope="{row}">
            <span>{{getStatus(row.fileStatus)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="描述">
          <template slot-scope="{row}">
            <div v-show="row.fileType===1">成功数量:{{row.successNum}}</div>
            <div v-show="row.fileType===1">失败数量:{{row.failureNum}}</div>
            <div v-show="row.causesFailure">
              <el-popover placement="bottom" width="130" trigger="hover" :content="row.causesFailure">
                <div style="width:120px" >失败原因:{{row.causesFailure||'-'}}</div>
                <div class="ellipsis" style="width: 40px;" slot="reference">失败原因</div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="{row}">
            <el-button type="text" style="text-align: center;" :disabled="!row.fileResultPath" size="medium" @click="() => row.fileResultPath && download(row.fileResultPath)">{{ row.fileResultPath ? '下载' : ' -- ' }}</el-button>            
            <el-button type="text" v-show="row.fileStatus===4 || row.fileResult !==1" size="medium" @click="() => fileTaskCancellationOrRetry(row.id,1)">重试</el-button>

            <!-- <span v-show="[4].includes(row.fileResult)" style="color:red">文件解析失败,请联系开发</span> -->
            <!-- <el-button type="text" v-show="row.fileStatus===4" size="medium" @click="() => fileTaskCancellationOrRetry(row.id,1)">重试</el-button>
            <el-button type="text" v-show="row.fileStatus===1" size="medium" @click="() => fileTaskCancellationOrRetry(row.id,0)">取消</el-button>
            <span v-show="row.fileStatus===2 || row.fileStatus===5">-</span> -->
          </template>
        </el-table-column>
      </el-table>
    </section>

    <!-- 页脚 -->
    <footer class="common-footer">
      <el-pagination background :current-page="listForm.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="listForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </footer>
  </div>
</template>

<script>
// import _ from 'lodash'
import API from '@/api'
// import XLSX from 'xlsx'
import moment from 'moment'
// import { downloadBlobFile } from '@/utils/index'


export default {
  name: 'export',
  data() {
    return {
      loading: false,
      moment: moment, // 处理日期插件
      total: 0, // 分页总数
      taskTime: undefined,
      listForm: {
        pageNumber: 1,
        pageSize: 20
      },
      fileTaskList: [],//导入导出任务列表
      downloadForm: {
        id: undefined,
        operatingStatus: undefined,
      }
    }
  },
  computed: {
    getStatus() {
      return (data) => {
        switch (data) {
          case 1:
            return '待处理'
          case 2:
            return '处理中'
          case 3:
            return '已完成'
          case 4:
            return '失败'
          case 5:
            return '已取消'
          case 6:
            return '已中断'

        }
      }
    }
  },
  watch: {
    filterCategoryText(value) {
      this.$refs.categoryTree.filter(value)
    },
    filterAlbumText(value) {
      this.$refs.albumTree.filter(value)
    }
  },
  created() {
    this.getFileTaskList()
  },
  activated() {
    this.getFileTaskList()
  },
  methods: {
    timeToString(time) {
      let date = new Date(time)
      let minute = date.getMinutes().toString()
      let seconds = date.getSeconds().toString()
      let hours = date.getHours().toString()
      let month = (date.getMonth() + 1).toString()
      let day = date.getDate().toString()
      if (minute.length === 1) minute = `0${minute}`
      if (seconds.length === 1) seconds = `0${seconds}`
      if (hours.length === 1) hours = `0${hours}`
      if (month.length === 1) month = `0${month}`
      if (day.length === 1) day = `0${day}`
      return `${date.getFullYear()}-${month}-${day} ${hours}:${minute}:${seconds}`
    },

    //列表
    getFileTaskList() {
      this.loading = true
      API.getFileTaskList(this.listForm).then(res => {
        this.fileTaskList = res.data.list
        this.total = res.data.total
        this.$tableScrollTop()
      }).finally(() => {
        this.loading = false
      })
    },

    // 筛选 - 日期选择器确认选定的值时触发的回调
    changeDatePicker(value) {
      if (value && value.length === 2) {
        this.listForm.startOperationTime = value[0]
        this.listForm.endOperationTime = value[1]
      } else {
        this.listForm.startOperationTime = undefined
        this.listForm.endOperationTime = undefined
      }
      this.getFileTaskList()
    },
    initPage() {
      this.listForm.pageNumber = 1
      this.getFileTaskList()
    },

    // 每页显示条数改变时的回调
    handleSizeChange(value) {
      this.listForm.pageSize = value
      this.getFileTaskList()
    },

    // 当前页发生改变时触发的回调
    handleCurrentChange(value) {
      this.listForm.pageNumber = value
      this.getFileTaskList()
    },
    download(file) {
      window.open(file)
    },
    fileTaskCancellationOrRetry(id, type) {
      API.fileTaskCancellationOrRetry({ id: id, operatingStatus: type }).then(() => {
        this.$message.success('操作成功')
        this.getFileTaskList()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.common-main {
  display: flex;
  height: 100%;
  min-width: 1578px;
  padding: 12px;
  flex-direction: column;
  background-color: #fff;

  .common-header {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    .left {
      > * {
        margin-right: 15px;
      }
      .el-input {
        width: 320px;
        .el-select {
          width: 100px;
        }
      }
    }
  }

  .common-section {
    height: calc(100vh - 194px);
    margin: 12px 0;
    .stock-img {
      width: 60px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid #f5f7fa;
      user-select: none;
      cursor: pointer;
    }
  }

  .common-footer {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: flex-end;
  }
}

.el-tree-box {
  height: 380px;
  overflow: auto;
}
.filter-album-text,
.filter-category-text {
  margin-bottom: 18px;
}
</style>